import { useState } from "react";
import { Link } from "react-router-dom";
// Assuming you have these components/context available:
import { useAdmin } from "../context/adminContext";
import LoginModal from "../components/LoginModel";
import RegisterModal from "../components/RegisterModule";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";

// 🎨 DYNAMIC COLOR SCHEME VARIABLES 🎨
const ACCENT_COLOR_HEX = "#A0522D"; // Sienna / Dark Caramel (for hovers/buttons)

// --- COLORS MATCHING YOUR IMAGE (Dark Blue/Navy Look) ---
const FOOTER_BG_DARK = "#001f3f"; // Navy Blue
const FOOTER_BG_BOTTOM = "#001226"; // Darker Navy
const TEXT_LIGHT = "text-gray-100"; // Light text color for contrast
const TEXT_MUTED = "text-gray-400"; // Muted text for contact info
// --------------------------------------------------------

function Footer() {
  const { admin, logout } = useAdmin();
  const [showRegister, setShowRegister] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  return (
    <footer style={{ backgroundColor: FOOTER_BG_DARK }} className={TEXT_LIGHT} role="contentinfo">
      <div className="max-w-7xl mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-4 gap-8 border-b border-gray-700">

        {/* 1. About Section (Shakshi Collection) */}
        <div className="md:col-span-1">
          <h4 className="text-xl font-bold mb-3">Shakshi Collection</h4>
          <p className={`text-sm ${TEXT_MUTED}`}>
            The best fashion store in Kaij for Women, Men, and Kids. Visit us for premium quality at best prices.
          </p>
          {/* Login/Register/Logout Buttons placed here */}
          <div className="mt-4 flex gap-3 text-sm">
            {admin ? (
              <button
                onClick={logout}
                className={`px-3 py-1 rounded font-semibold transition duration-200 hover:bg-opacity-80`}
                style={{ color: TEXT_LIGHT, backgroundColor: ACCENT_COLOR_HEX, boxShadow: `0 2px 4px rgba(0, 0, 0, 0.2)` }}
              >
                Logout
              </button>
            ) : (
              <>
                <button
                  onClick={() => setShowLogin(true)}
                  className={`px-3 py-1 rounded font-semibold transition duration-200 hover:bg-opacity-80`}
                  style={{ color: TEXT_LIGHT, backgroundColor: ACCENT_COLOR_HEX }}
                >
                  Login
                </button>
                <button
                  onClick={() => setShowRegister(true)}
                  className={`px-3 py-1 rounded font-semibold transition duration-200 hover:bg-gray-700 border border-gray-600`}
                  style={{ color: TEXT_LIGHT }}
                >
                  Register
                </button>
              </>
            )}
          </div>
        </div>

        {/* 2. Quick Links (Centralized) */}
        <div>
          <h4 className="text-lg font-bold mb-3">Quick Links</h4>
          <ul className="text-sm space-y-2">
            <li>
              <Link to="/" className={`hover:text-[${ACCENT_COLOR_HEX}] ${TEXT_MUTED}`}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/collections" className={`hover:text-[${ACCENT_COLOR_HEX}] ${TEXT_MUTED}`}>
                Collections
              </Link>
            </li>
            <li>
              <Link to="/contact" className={`hover:text-[${ACCENT_COLOR_HEX}] ${TEXT_MUTED}`}>
                Contact
              </Link>
            </li>
            <li>
              <Link to="/dashboard" className={`hover:text-[${ACCENT_COLOR_HEX}] ${TEXT_MUTED}`}>
                Admin
              </Link>
            </li>
          </ul>
        </div>

        {/* 3. Contact Info */}
        <div>
          <h4 className="text-lg font-bold mb-3">Contact Us</h4>
          <ul className={`text-sm space-y-2 ${TEXT_MUTED}`}>
            <li className="flex items-center gap-2">
              <span className="text-xl" style={{ color: ACCENT_COLOR_HEX }}>
                &#x23F1; {/* Clock icon placeholder */}
              </span>
              <p>Kaij, Maharashtra, 431123</p>
            </li>
            <li className="flex items-center gap-2">
              <span className="text-xl" style={{ color: ACCENT_COLOR_HEX }}>
                &#x260E; {/* Phone icon placeholder */}
              </span>
              <p>+91 XXXXXXXXXX</p>
            </li>
            <li className="flex items-center gap-2">
              <span className="text-xl" style={{ color: ACCENT_COLOR_HEX }}>
                &#x2709; {/* Email icon placeholder */}
              </span>
              <p>shakshicollection@example.com</p>
            </li>
          </ul>
        </div>

        {/* 4. Follow Us (Social Media Icons) */}
        <div className="md:text-left">
          <h4 className="text-lg font-bold mb-3">Follow Us</h4>
          <div className="flex gap-4 text-2xl">
            <a href="#" aria-label="Facebook" className={`hover:text-[${ACCENT_COLOR_HEX}]`}>
              <FaFacebook />
            </a>
            <a href="#" aria-label="Instagram" className={`hover:text-[${ACCENT_COLOR_HEX}]`}>
              <FaInstagram />
            </a>
            <a href="https://wa.me/91XXXXXXXXXX" aria-label="WhatsApp" className={`hover:text-[${ACCENT_COLOR_HEX}]`}>
              <FaWhatsapp />
            </a>
          </div>
        </div>

      </div>

      {/* Bottom Bar (Copyright) */}
      <div style={{ backgroundColor: FOOTER_BG_BOTTOM }} className="px-6 py-4 text-sm text-center">
        <p className="text-gray-400">
          © {new Date().getFullYear()} Shakshi Collection. All Rights Reserved.
        </p>
      </div>

      {showRegister && <RegisterModal onClose={() => setShowRegister(false)} />}
      {showLogin && <LoginModal onClose={() => setShowLogin(false)} />}
    </footer>
  );
}

export default Footer;